<template>
  <div class="join-agency">
    <van-nav-bar :title="$t('title.join_agency')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <div class="join-agency-img">
      <img src="../assets/img/creator/join_agency_name.png"/>
    </div>
    <!-- 副标题 -->
    <div class="subtitle">{{ $t('column.to_become_creators')}}</div>
    <!-- 表单卡片 -->
    <div class="form-card">
      <!-- 卡片标题 -->
      <div class="card-title">{{ $t('column.join_agency_actively')}}</div>
      <!-- 表单内容 -->
      <div class="form-content">
        <!-- 提示文字 -->
        <div class="form-hint">{{ $t('column.agency_id_provided_by_agency')}}</div>
        <!-- 输入框 -->
        <van-field
          v-model="agencyId"
          :placeholder="$t('column.please_input_agency_id')"
          class="agency-input"
          :border="false"
        />
        <!-- 绑定按钮 -->
        <van-button
          class="bind-button"
          @click="bindAgency"
          :loading="loading"
        >
          {{ $t('column.bind')}}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import Toast from 'vant/lib/toast'
import axios from "axios";

export default {
  data() {
    return {
      agencyId: '',
      loading: false
    }
  },
  methods: {
    // 返回上一页
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    creator_success () {
      const token = this.$route.query.token;
      const uid = this.$route.query.uid
      this.$router.push({path: '/creator_success', query: {uid: uid, token: token}});
    },
    // 绑定代理
    async bindAgency() {
      if (!this.agencyId.trim()) {
        Toast('Please input the agency id')
        return
      }
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      // 这里添加绑定代理的API调用
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_user_bind",{ params:{ uid: uid, token: token, bind_user_id: this.agencyId }}).then(res =>{
        console.log(res.data)
        this.loading = false
        Toast(res.data.error)
        if(res.data.status===1){
          // 绑定成功后可能需要跳转到其他页面
          this.creator_success()
        }
      })
    }
  }
}
</script>

<style scoped>
.join-agency {
  min-height: 100vh;
  background: linear-gradient(180deg, #E6F3FF 0%, #F0F8FF 50%, #FAFCFF 100%);
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
.subtitle {
  text-align: center;
  font-size: 16px;
  color: #FF61F5;
  font-weight: 500;
  margin-top: 8vw;
  letter-spacing: 0.5px;
}

.form-card {
  background: linear-gradient(to right, #FFDEFA, #F8F5FA,#EFD8FF);
  border-radius: 24px;
  width: 90%;
  margin: 3vw auto;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(255, 182, 193, 0.2);

}
.form-content{
  width: 90%;
  margin: 4vw auto;
  background: #ffffff;
  border-radius: 24px;
  padding-top: 5vw;
  padding-bottom: 5vw;
}
.card-title {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #0F0F0F;
  height: 7vw;line-height: 7vw;
  margin-top: 4vw;
  letter-spacing: 0.2px;

}
.form-hint {
  font-size: 14px;
  color: #1A1A1A;
  text-align: center;
  height: 6vw;
  line-height: 6vw;
  font-weight: 400;
}

.agency-input {
  background: #F5F6F8;
  border-radius: 3vw;
  width: 90%;
  margin: 5vw auto;

}
.bind-button {
  width: 90%;
  height: 50px;
  background: #FF69E6;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
  box-shadow: 0 4px 20px rgba(255, 20, 147, 0.3);
  transition: all 0.3s ease;
  margin: 0 5%;
}
.bind-button:active {
  transform: translateY(1px);
  box-shadow: 0 2px 12px rgba(255, 20, 147, 0.4);
}

</style>


// WEBPACK FOOTER //
// src/components/join_agency.vue